import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { Cart, OrderRecap, OrderVerified, PriceBreakdown } from 'services/order/order.type';
import { RootState } from '../store';

export const orderSliceName = 'order';

export type OrderState = OrderVerified | null;

const initialState: OrderState = null;

export const orderSlice = createSlice<OrderState, SliceCaseReducers<OrderState>, string>({
    name: orderSliceName,
    initialState,
    reducers: {
        updateOrder: (state, action: PayloadAction<OrderState>) => action.payload,
        resetOrder: (_state, _action: PayloadAction) => {
            return null;
        },
    },
});

export const getOrder = (state: RootState): OrderState => state.order;
export const getOrderCart = (state: RootState): Cart => state.order?.cart || [];
export const getOrderRecap = (state: RootState): OrderRecap | undefined => state.order?.recap;
export const getOrderProductCount = (state: RootState): number =>
    state.order?.recap.products.length || 0;
export const getOrderTotalPriceBreakdown = (state: RootState): PriceBreakdown | undefined =>
    state.order?.recap.totalPrice;
export const getOrderTotalInclTax = (state: RootState): number =>
    state.order?.recap.totalPrice.totalInclTax || 0;

export const { updateOrder, resetOrder } = orderSlice.actions;
